function ThumbsUpIconFilled({ color = 'currentColor', height = '24', width = '24' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M15.0003 17.4997H6.66699V6.66634L12.5003 0.833008L13.542 1.87467C13.6392 1.9719 13.7191 2.10384 13.7816 2.27051C13.8441 2.43717 13.8753 2.5969 13.8753 2.74967V3.04134L12.9587 6.66634H17.5003C17.9448 6.66634 18.3337 6.83301 18.667 7.16634C19.0003 7.49967 19.167 7.88856 19.167 8.33301V9.99967C19.167 10.0969 19.1566 10.2011 19.1357 10.3122C19.1149 10.4233 19.0837 10.5275 19.042 10.6247L16.542 16.4997C16.417 16.7775 16.2087 17.0136 15.917 17.208C15.6253 17.4025 15.3198 17.4997 15.0003 17.4997ZM5.00033 6.66634V17.4997H1.66699V6.66634H5.00033Z"
        fill={color}
      />
    </svg>
  );
}
export default ThumbsUpIconFilled;
